<template>
  <el-container style="background-color: #ecec95">
    <div class="header flex al-cn ju-sp">
      <div class="logo flex al-cn pointer" @click="routerGo('/')">
        <img src="@/assets/home-img/leafage.png" alt/>
        <div class="title font-bold pl5">me, myself, and i</div>
      </div>
      <el-menu
          style="border-bottom-width: 0;margin-right: 30px;"
          :default-active="defaultActive"
          class="el-menu-demo menu"
          mode="horizontal"
          @select="handleSelect"
          background-color="#F6C796"
          text-color="#262626"
          active-text-color="#fff"
          :router="router">
        <el-menu-item index="/">home</el-menu-item>
        <el-menu-item index="/mindfulness/exercises">mindfulness tools</el-menu-item>
        <el-menu-item index="/mindfulness/youth">resources</el-menu-item>
        <el-menu-item index="/mindfulness/journal">store</el-menu-item>
        <el-menu-item index="/about/about-us">about</el-menu-item>
      </el-menu>
    </div>
    <el-main class="main">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import login from "@/views/Login.vue";

export default {
  data() {
    return {
      router: true,
      //路由激活
      defaultActive: "/Home",
      isShow: true,
      input: '',
    };
  },
  watch: {
    $route(val) {
      this.defaultActive = val.fullPath;
      // console.log(val)
    }
  },
  mounted() {
    this.defaultActive = this.$route.fullPath;
  },
  methods: {
    handleSelect(key) {
      this.defaultActive = key
    },
    //路由跳转
    routerGo(path) {
      this.$router.push({path: path});
    },
    loginIn() {
      this.$router.push({name: "login"});
    },
  }
};
</script>

<style lang="scss">
//.menu > .el-menu-item.is-active {
.menu > .el-menu-item {
  border-bottom: 0 solid #fff !important;
  font-weight: bold;
  font-family: Arial Rounded MT bold;
  font-size: 23px;
  color: #000000;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 82px;
  background: #F6C796;

  .logo {
    margin-left: 50px;

    .title {
      font-size: 33px;
    }

    img {
      width: 60px;
      height: 75px;
    }
  }
}
.main{
  padding: 0;
  margin-top: 82px;
  font-family: Arial Rounded MT Bold
}
</style>
